import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { PatchRegionRequestBody } from '@/api/apis/facilities';
import { regionsQueryKeys } from '@/queries/regions/regions.keys';

export const useUpdateRegionMutation = (regionId: string) => {
  return useMutation({
    mutationFn: (body: PatchRegionRequestBody) => api.regions.updateRegionById(regionId, body),
    meta: {
      invalidates: [regionsQueryKeys.getList(), regionsQueryKeys.getItem(regionId)],
    },
  });
};
